<template>
  <div>
    <div v-if="tabList.length > 1 || showOneTab">
      <input type="hidden" id="isPrint" value="false" />
      <input type="hidden" id="hidePrintTitle" value="false" />
      <vs-tabs :value="tabIndex">
        <vs-tab v-for="tab in tabList" :key="`tab_${tab.label}`" :label="tab.label" class="px-1" @click="moveTab(tab.boardId, tab.moveType, tab.key)">
          <component v-if="tab.exception" :is="tab.component" />
          <ApprovalDocument2
            v-else-if="tab.isApproval"
            :tab="tab"
            :doc-info="docInfo"
            :docProjectId="docProjectId"
            :permission="getPermission"
            :usePrevPost="tab.usePrevPost"
            :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
            @delete="onClickApprovalDelete"
            @close="onClickApprovalClose"
            @recall="onClickApprovalRecall"
            @upload="onClickApprovalUpload"
            @update="onClickApprovalSave"
            @save="onClickApprovalSave"
            @approval="onClickApprovalOk"
            @reject="onClickApprovalNo"
            @prevPost="onClickPrevPost"
          >
            <template #header="props">
              <div v-if="tab.useHeaderDate" class="h4 flex" style="align-items: center">
                <div id="print-label">
                  <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
                </div>

                <vs-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.year" :readonly="true" />년
                <vs-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" min="1" max="12" />월
              </div>
              <div v-else id="print-label">
                <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
              </div>
            </template>

            <template #body="props">
              <component ref="approvalDocument" :is="tab.component" :tab="tab" :board="props.board" :is-print="props.isPrint" :header="form.header" v-model="form.body" />
              <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
            </template>
          </ApprovalDocument2>
          <NormalDocument
            v-else
            :tab="tab"
            :created="useCreated"
            :docProjectId="docProjectId"
            :permission="getPermission"
            :usePrevPost="tab.usePrevPost"
            :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
            @move="onMoveNormalPage"
            @remove="onClickNormalRemove"
            @save="onClickNormalSave"
            @prevPost="onClickPrevPost"
          >
            <template #header="props">
              <div v-if="tab.useHeaderDate" class="h4 flex" style="align-items: center">
                <div id="print-label">
                  <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
                </div>

                <vs-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.year" :readonly="true" />년
                <vs-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" min="1" max="12" />월
              </div>
              <div v-else id="print-label">
                <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
              </div>
            </template>
            <template #body="props">
              <component ref="normalDocument" :is="tab.component" :tab="tab" :board="props.board" :is-print="props.isPrint" v-model="form.body" />
              <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
            </template>
          </NormalDocument>
        </vs-tab>
      </vs-tabs>
    </div>
    <div v-else-if="tabList.length === 1">
      <input type="hidden" id="isPrint" value="false" />
      <input type="hidden" id="hidePrintTitle" value="false" />
      <div v-for="tab in tabList" :key="`tab_${tab.label}`" :label="tab.label">
        <component v-if="tab.exception" :is="tab.component" />
        <ApprovalDocument2
          v-else-if="tab.isApproval"
          :tab="tab"
          :doc-info="docInfo"
          :docProjectId="docProjectId"
          :permission="getPermission"
          :usePrevPost="tab.usePrevPost"
          :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
          @delete="onClickApprovalDelete"
          @close="onClickApprovalClose"
          @recall="onClickApprovalRecall"
          @upload="onClickApprovalUpload"
          @update="onClickApprovalSave"
          @save="onClickApprovalSave"
          @approval="onClickApprovalOk"
          @reject="onClickApprovalNo"
          @prevPost="onClickPrevPost"
        >
          <template #header="props">
            <div v-if="tab.useHeaderDate" class="h4 flex" style="align-items: center">
              <div id="print-label">
                <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
              </div>

              <vs-input class="ml-8 mr-2" style="width: 100px" v-model="form.header.year" :readonly="true" />년
              <vss-input type="number" class="ml-8 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" min="1" max="12" />월
            </div>

            <div v-else id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
            </div>
          </template>

          <template #body="props">
            <component ref="approvalDocument" :is="tab.component" :tab="tab" :board="props.board" :header="form.header" :is-print="props.isPrint" v-model="form.body" @EnableSave="handleEnableSave" />
            <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
          </template>
        </ApprovalDocument2>
        <NormalDocument
          v-else
          :tab="tab"
          :created="useCreated"
          :docProjectId="docProjectId"
          :permission="getPermission"
          :usePrevPost="tab.usePrevPost"
          :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
          @move="onMoveNormalPage"
          @remove="onClickNormalRemove"
          @save="onClickNormalSave"
          @prevPost="onClickPrevPost"
        >
          <template #header="props">
            <div v-if="tab.useHeaderDate" class="h4 flex gap-4" style="align-items: center">
              <div id="print-label">
                <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
              </div>

              <div v-if="tab.headerDateType === 'date'" class="flex items-center">
                <date-selector class="mr-2" style="width: 140px" v-model="form.header.date" :readonly="props.board.readonly || !!postId" />
              </div>
              <div v-else-if="tab.headerDateType === 'year'" class="flex items-center">
                <vs-input
                  type="number"
                  class="ml-2"
                  style="width: 100px"
                  v-model="form.header.year"
                  :readonly="props.board.readonly || !!postId"
                  :min="2000"
                  :max="new Date().getFullYear() + 100"
                  @focusout="
                  () => {
                    if (form.header.year < 2000) form.header.year = new Date().getFullYear();
                    if (form.header.year > new Date().getFullYear() + 100) form.header.year = new Date().getFullYear();
                  }
                "
                />&nbsp;년
              </div>
              <div v-else class="flex items-center">
                <vs-input
                  type="number"
                  class="mr-2"
                  style="width: 100px"
                  v-model="form.header.year"
                  :readonly="props.board.readonly || !!postId"
                  :min="2000"
                  :max="new Date().getFullYear() + 100"
                  @focusout="
                  () => {
                    if (form.header.year < 2000) form.header.year = new Date().getFullYear();
                    if (form.header.year > new Date().getFullYear() + 100) form.header.year = new Date().getFullYear();
                  }
                "
                />년 <vs-input type="number" class="ml-4 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" :min="1" :max="12" />월
              </div>
            </div>
            <div v-else id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
            </div>
          </template>
          <template #body="props">
            <component ref="normalDocument" :is="tab.component" :tab="tab" :board="props.board" :header="form.header" :is-print="props.isPrint" v-model="form.body" @EnableSave="handleEnableSave" />
            <FileDownload v-if="!props.isPrint && !tab.hideFileDownload" />
          </template>
        </NormalDocument>
      </div>
    </div>

    <PopupLoadPrevBoard v-model="showLoadPrevBoardPopup" @selectRowData="updatePrevForm" />
  </div>
</template>

<script>
/* eslint-disable brace-style */
import breadcrumb from "@/views/boards/tab/breadcrumb";
import tabItems from "@/views/boards/tab/tab-items";
import Exception01 from "@/views/boards/exception/Exception01";
import Exception02 from "@/views/boards/exception/Exception02";
import Exception03 from "@/views/boards/exception/Exception03";
import Exception04 from "@/views/boards/exception/Exception04";
import Exception06 from "@/views/boards/exception/Exception06";

import ApprovalDocument2 from "@/views/write/document/ApprovalDocument2";
import NormalDocument from "@/views/write/document/NormalDocument";

import FileDownload from "@/components/FileDownload.vue";
import singlePageWrite from "@/views/boards/single-page/writeIndex";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  name: "Write",
  components: {
    PopupLoadPrevBoard,
    NormalDocument,
    ApprovalDocument2,
    Exception01,
    Exception02,
    Exception03,
    Exception04,
    Exception06,
    FileDownload,
  },
  data() {
    return {
      tabItems,
      breadcrumb,
      tabIndex: 0,
      tabList: [],

      oldForm: {},
      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
        },
        body: {},
      },
      docInfo: {},
      docProjectId: "",

      isApproval: false,
      isPrint: false,
      enableSave: true,
      showLoadPrevBoardPopup: false,
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    boardSlug() {
      for (const tab of this.tabList) {
        if (`${tab.boardId}` === `${this.boardId}`) {
          return tab.slug;
        }
      }
      return "";
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    useCreated() {
      // if (this.boardId === ) {
      //
      // }
      return this.enableSave;
    },
    header() {
      return this.form.header;
    },

    memberInfoBoards() {
      if (this.$store.state.member.memberInfo.boards) {
        return this.$store.state.member.memberInfo.boards;
      } else {
        // 정보가 없으면, API에서 불러온다
        this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
      }
    },
    getPermission() {
      let permission = { c: 0, r: 0, u: 0, d: 0, v: 0 };
      const boards = this.memberInfoBoards;

      if (boards) {
        let board = boards.find((b) => parseInt(b.id) === this.boardId);

        if (!!board && !!board.pivot) {
          let pivot = { c: 0, r: 0, u: 0, d: 0, v: 0 };

          if (board.pivot.project_id) {
            board = boards.find((b) => parseInt(b.pivot.board_id) === this.boardId && parseInt(b.pivot.project_id) === this.projectId);
            if (board) {
              pivot = { ...board.pivot };
            }
          } else {
            pivot = { ...board.pivot };
          }
          permission = { c: pivot.c, r: pivot.r, u: pivot.u, d: pivot.d, v: pivot.v };
        }
      }
      return permission;
    },
    showOneTab() {
      // const enabledIds = [286];
      const enabledIds = [671, 965];

      // 탭이 노출되기 원하는 boardId인 경우
      // true를 반환시켜준다.
      return !!enabledIds.find((id) => id === this.boardId);
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.form.header.full = `${value.year}-${value.month > 9 ? value.month : `0${value.month}`}-01`;
        }
      },
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
  },
  beforeMount() {
    this.oldForm = JSON.parse(JSON.stringify(this.form));
    this.initBreadcrumb();
    this.initBackButtonRouteGuard();
    this.initTab();
  },
  async mounted() {
    if (this.postId) {
      if (this.isApproval) {
        await this.loadApprovalPost();
      } else {
        await this.loadBoardPost();
      }
    }
  },
  methods: {
    initBreadcrumb() {
      const breadcrumb = [{ title: "Home" }];
      let key = `${this.boardId}`;

      // 브래드크럼의 이름이 프로젝트 번호와 연결되어 있으면, 해당 정보를 가져온다
      if (this.breadcrumb[`${this.projectId}.${this.boardId}`]) {
        key = `${this.projectId}.${this.boardId}`;
      }
      breadcrumb.push(...this.breadcrumb[key]);

      if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
      this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
    },
    initBackButtonRouteGuard() {
      const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
        const isNext = JSON.stringify(this.oldForm) === JSON.stringify(this.form) || confirm("저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?");
        if (isNext) {
          document.querySelectorAll(".con-vs-popup").forEach((el) => {
            el.style.display = "none";
          });
          next(true);
        }
      });
      this.$once("hook:destroyed", () => {
        backButtonRouteGuard();
      });
    },
    initTab() {
      if (this.boardId === 53 || this.boardId === 54 || this.boardId === 55) {
        this.addTab(53);
        this.addTab(54);
        this.addTab(55);
        if (this.boardId === 53) this.tabIndex = 0;
        else if (this.boardId === 54) this.tabIndex = 1;
        else if (this.boardId === 55) this.tabIndex = 2;
      } else if (this.boardId === 58 || this.boardId === 59 || this.boardId === 60) {
        this.addTab(58);
        this.addTab(59);
        this.addTab(60);
        if (this.boardId === 58) this.tabIndex = 0;
        else if (this.boardId === 59) this.tabIndex = 1;
        else if (this.boardId === 60) this.tabIndex = 2;
      } else if (this.boardId === 62 || this.boardId === 63) {
        this.addTab(62);
        this.addTab(63);
        this.addSubTab("아차사고D/B");
        if (this.boardId === 62) this.tabIndex = 0;
        else if (this.boardId === 63) this.tabIndex = 1;
      } else if (this.boardId === 64 || this.boardId === 65 || this.boardId === 66 || this.boardId === 67 || this.boardId === 68 || this.boardId === 69) {
        this.addTab(64);
        this.addTab(65);
        this.addTab(66);
        this.addTab(67);
        this.addTab(68);
        this.addTab(69);
        if (this.boardId === 64) this.tabIndex = 0;
        else if (this.boardId === 65) this.tabIndex = 1;
        else if (this.boardId === 66) this.tabIndex = 2;
        else if (this.boardId === 67) this.tabIndex = 3;
        else if (this.boardId === 68) this.tabIndex = 4;
        else if (this.boardId === 69) this.tabIndex = 5;
      } else if (this.boardId === 71 || this.boardId === 72 || this.boardId === 73 || this.boardId === 74 || this.boardId === 75) {
        this.addTab(74);
        this.addTab(75);
        this.addTab(71);
        this.addTab(72);
        this.addTab(73);
        if (this.boardId === 74) this.tabIndex = 0;
        else if (this.boardId === 75) this.tabIndex = 1;
        else if (this.boardId === 71) this.tabIndex = 2;
        else if (this.boardId === 72) this.tabIndex = 3;
        else if (this.boardId === 73) this.tabIndex = 4;
      } else if (this.boardId === 76 || this.boardId === 77) {
        this.addTab(76);
        this.addTab(77);
        this.addSubTab("형태별분류");
        if (this.boardId === 76) this.tabIndex = 0;
        else if (this.boardId === 77) this.tabIndex = 1;
      } else if (this.boardId === 78 || this.boardId === 79 || this.boardId === 87) {
        this.addTab(78);
        this.addTab(79);
        this.addTab(87);
        if (this.boardId === 78) this.tabIndex = 0;
        else if (this.boardId === 79) this.tabIndex = 1;
        else if (this.boardId === 87) this.tabIndex = 2;
      } else if (this.boardId === 80 || this.boardId === 81 || this.boardId === 88) {
        this.addTab(80);
        this.addTab(81);
        this.addTab(88);
        if (this.boardId === 80) this.tabIndex = 0;
        else if (this.boardId === 81) this.tabIndex = 1;
        else if (this.boardId === 88) this.tabIndex = 2;
      } else if (this.boardId === 82 || this.boardId === 83) {
        this.addTab(82);
        this.addTab(83);
        if (this.boardId === 82) this.tabIndex = 0;
        else if (this.boardId === 83) this.tabIndex = 1;
      } else if (this.boardId === 84 || this.boardId === 85) {
        this.addTab(84);
        this.addTab(85);
        if (this.boardId === 84) this.tabIndex = 0;
        else if (this.boardId === 85) this.tabIndex = 1;
      } else if (this.boardId === 89) {
        this.addTab(89);
        this.addSubTab("조직도");
        if (this.boardId === 89) this.tabIndex = 0;
        // } else if (this.boardId === 129 || this.boardId === 130) {
        //   this.addTab(130);
        //   this.addTab(129);
        //   if (this.boardId === 130) this.tabIndex = 0;
        //   else if (this.boardId === 129) this.tabIndex = 1;
      } else if (this.boardId === 108 || this.boardId === 156 || this.boardId === 157 || this.boardId === 158 || this.boardId === 159 || this.boardId === 305 || this.boardId === 306) {

        if (`${this.projectId}` === "2") {
          this.addTab(664);
          this.addTab(665);
          this.addTab(157);
          this.addTab(667);
          if (this.boardId === 664) this.tabIndex = 0;
          if (this.boardId === 665) this.tabIndex = 1;
          if (this.boardId === 157) this.tabIndex = 2;
          if (this.boardId === 667) this.tabIndex = 3;
        } else {
          this.addTab(108);
          this.addTab(156);
          this.addTab(157);
          this.addTab(158);
          this.addTab(159);
          this.addTab(305);
          this.addTab(306);
          if (this.boardId === 108) this.tabIndex = 0;
          if (this.boardId === 156) this.tabIndex = 1;
          if (this.boardId === 157) this.tabIndex = 2;
          if (this.boardId === 158) this.tabIndex = 3;
          if (this.boardId === 159) this.tabIndex = 4;
          if (this.boardId === 305) this.tabIndex = 5;
          if (this.boardId === 306) this.tabIndex = 6;
        }

      } else if (this.boardId === 119 || this.boardId === 120 || this.boardId === 121 || this.boardId === 122 || this.boardId === 123 || this.boardId === 124 || this.boardId === 125) {
        this.addTab(119);
        this.addTab(120);
        this.addTab(121);
        this.addTab(122);
        this.addTab(123);
        // this.addTab(124);  // 2022.12.19 https://app.clickup.com/t/864dhnpjc
        this.addTab(125);
        if (this.boardId === 119) this.tabIndex = 0;
        else if (this.boardId === 120) this.tabIndex = 1;
        else if (this.boardId === 121) this.tabIndex = 2;
        else if (this.boardId === 122) this.tabIndex = 3;
        else if (this.boardId === 123) this.tabIndex = 4;
        else if (this.boardId === 124) this.tabIndex = 5;
        else if (this.boardId === 125) this.tabIndex = 6;
      } else if (this.boardId === 144 || this.boardId === 145 || this.boardId === 146) {
        this.addTab(144);
        this.addTab(145);
        this.addTab(146);
        if (this.boardId === 144) this.tabIndex = 0;
        if (this.boardId === 145) this.tabIndex = 1;
        if (this.boardId === 146) this.tabIndex = 2;
      } else if (this.boardId === 153) {
        if (Number(`${this.projectId}`) === 2) {
          this.addTabInLabel(153, "안전보건협의체");
        } else {
          this.addTabInLabel(153, "노사협의체");
        }
      } else if (this.boardId === 216 || this.boardId === 217 || this.boardId === 218) {
        this.addTab(216);
        this.addTab(217);
        this.addTab(218);
        if (this.boardId === 216) this.tabIndex = 0;
        if (this.boardId === 217) this.tabIndex = 1;
        if (this.boardId === 218) this.tabIndex = 2;
      } else if (this.boardId === 239 || this.boardId === 240 || this.boardId === 241) {
        this.addTab(239);
        this.addTab(240);
        this.addTab(241);
        if (this.boardId === 239) this.tabIndex = 0;
        if (this.boardId === 240) this.tabIndex = 1;
        if (this.boardId === 241) this.tabIndex = 2;
      } /*else if (
        this.boardId === 246 ||
        this.boardId === 247 ||
        this.boardId === 248 ||
        this.boardId === 249
      ) {
        this.addTab(246);
        this.addTab(247);
        this.addTab(248);
        this.addTab(249);
        if (this.boardId === 246) this.tabIndex = 0;
        if (this.boardId === 247) this.tabIndex = 1;
        if (this.boardId === 248) this.tabIndex = 2;
        if (this.boardId === 249) this.tabIndex = 3;
      }*/ else if (this.boardId === 253 || this.boardId === 254 || this.boardId === 255) {
        this.addTab(253);
        this.addTab(254);
        this.addTab(255);
        if (this.boardId === 253) this.tabIndex = 0;
        if (this.boardId === 254) this.tabIndex = 1;
        if (this.boardId === 255) this.tabIndex = 2;
      } else if (this.boardId === 285) {
        if (Number(`${this.projectId}`) === 3) {
          this.addTabInLabel(285, "안전보건총괄책임자 선임");
        } else {
          this.addTabInLabel(285, "안전보건관리(총괄)책임자 선임");
        }
      } else if (this.boardId === 290) {
        if (Number(`${this.projectId}`) === 2) {
          this.addTabInLabel(290, "보건 순회점검표");
        } else {
          this.addTab(290);
        }
      } else if (this.boardId === 291) {
        if (Number(`${this.projectId}`) === 2) {
          this.addTabInLabel(291, "안전 순회점검표");
        } else {
          this.addTab(291);
        }
      } else if (this.boardId === 294 || this.boardId === 295) {
        this.addTab(294);
        this.addTab(295);
        if (this.boardId === 294) this.tabIndex = 0;
        if (this.boardId === 295) this.tabIndex = 1;
      } else if (this.boardId === 299 || this.boardId === 358 || this.boardId === 456) {
        if (Number(`${this.projectId}`) === 1) {
          this.addTabInLabel(358, "내부종사자");
          this.addTabInLabel(299, "도급·용역·위탁");
          this.addTabInLabel(456, "발주사업");
          if (this.boardId === 358) this.tabIndex = 0;
          if (this.boardId === 299) this.tabIndex = 1;
          if (this.boardId === 456) this.tabIndex = 2;
        } else {
          this.addTab(this.boardId);
        }
      } else if (this.boardId === 352 || this.boardId === 353 || this.boardId === 354) {
        this.addTab(352);
        this.addTab(353);
        this.addTab(354);
        if (this.boardId === 352) this.tabIndex = 0;
        if (this.boardId === 353) this.tabIndex = 1;
        if (this.boardId === 354) this.tabIndex = 2;
      } else if (this.boardId === 385 || this.boardId === 392 || this.boardId === 394) {
        this.addTab(385);
        this.addTab(392);
        this.addTab(394);
        if (this.boardId === 385) this.tabIndex = 0;
        if (this.boardId === 392) this.tabIndex = 1;
        if (this.boardId === 394) this.tabIndex = 2;
      } else if (this.boardId === 386 || this.boardId === 393 || this.boardId === 395) {
        this.addTab(386);
        this.addTab(393);
        this.addTab(395);
        if (this.boardId === 386) this.tabIndex = 0;
        if (this.boardId === 393) this.tabIndex = 1;
        if (this.boardId === 395) this.tabIndex = 2;
      } else if (this.boardId === 914 || this.boardId === 916) {
        this.addTab(914);
        this.addTab(916);
        if (this.boardId === 914) this.tabIndex = 0;
        if (this.boardId === 916) this.tabIndex = 1;
      } else if (this.boardId === 667 || this.boardId === 912) {
        this.addTab(912);
        this.addTab(667);
        if (this.boardId === 912) this.tabIndex = 0;
        if (this.boardId === 667) this.tabIndex = 1;
      } else if (this.boardId === 983 || this.boardId === 935) {
        this.addTab(983);
        this.addTab(935);
        if (this.boardId === 983) this.tabIndex = 0;
        if (this.boardId === 935) this.tabIndex = 1;
      } else if (this.$route.params.boardId === "현장대리인_안전보건_경영방침" || this.boardId === 284) {
        this.addSubTab("현장대리인_안전보건_경영방침");
        this.addTab(284);
        if (this.$route.params.boardId === "현장대리인_안전보건_경영방침") this.tabIndex = 0;
        if (this.boardId === 284) this.tabIndex = 1;
      } else if (this.$route.params.boardId === "checkCerebrovascular" || this.boardId === 368 || this.boardId === 369) {
        this.addSubTab("checkCerebrovascular");
        this.addTab(368);
        this.addTab(369);
        if (this.$route.params.boardId === "checkCerebrovascular") this.tabIndex = 0;
        if (this.boardId === 368) this.tabIndex = 1;
        if (this.boardId === 369) this.tabIndex = 2;
      } else if (this.boardId === 637) {
        this.addTab(637);
        this.addPageTab(637, '교량 대량입력');
        if (this.boardId === 637) this.tabIndex = 0;
      } else if (this.boardId === 638) {
        this.addTab(638);
        this.addPageTab(638, '터널 대량입력');
        if (this.boardId === 638) this.tabIndex = 0;
      } else if (this.boardId === 639) {
        this.addTab(639);
        this.addPageTab(639, '옹벽 및 절토사면 대량입력');
        if (this.boardId === 639) this.tabIndex = 0;
      } else if (this.boardId === 940 || this.boardId === 938) {
        this.addTab(940);
        this.addTab(938);
        if (this.boardId === 940) this.tabIndex = 0;
        if (this.boardId === 938) this.tabIndex = 1;
      } else if (this.boardId === 946 || this.boardId === 967 || this.boardId === 968) {
        this.addTab(946)
        this.addTab(967)
        this.addTab(968)
        if (this.boardId === 946) this.tabIndex = 0
        if (this.boardId === 967) this.tabIndex = 1
        if (this.boardId === 968) this.tabIndex = 2
      } else {
        this.addTab(this.boardId);
      }

      for (const tab of this.tabList) {
        if (`${tab.boardId}` === `${this.boardId}`) {
          this.isApproval = tab.isApproval;
        }
      }
    },
    addTab(_boardId) {
      const slug = `board-${_boardId}`;
      const component = singlePageWrite[`${_boardId}_write`];
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({ boardId, slug, component, ...item });
      }
    },
    addPageTab(_boardId, label) {
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        const slug = `board-${_boardId}`;
        const component = singlePageWrite[`${_boardId}_write`];
        this.tabList.push({
          ...item,
          moveType: 'page',
          label: label || item.label,
          boardId,
          component,
        });
      }
    },
    addTabInLabel(_boardId, label) {
      const slug = `board-${_boardId}`;
      const component = singlePageWrite[`${_boardId}_write`];
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({ boardId, slug, component, ...item });
        this.tabList[this.tabList.length - 1].label = label;
      }
    },
    addSubTab(key) {
      if (key === "아차사고D/B") this.tabList.push({
        key: "아차사고D/B",
        label: "아차사고 D/B",
        component: "exception01",
        exception: true,
      });
      if (key === "형태별분류") this.tabList.push({
        key: "형태별분류",
        label: "형태별 분류",
        component: "exception02",
        exception: true,
      });
      if (key === "조직도") this.tabList.push({
        key: "조직도",
        label: "조직도",
        component: "exception03",
        exception: true,
      });
      if (key === "현장대리인_안전보건_경영방침") this.tabList.push({ key: "현장대리인_안전보건_경영방침", label: "현장대리인 안전보건 경영방침", component: "exception04", exception: true });
      if (key === "checkCerebrovascular") this.tabList.push({ key: "checkCerebrovascular", label: "뇌심혈관질환 발병위험도 평가 및 사후관리 절차 개요", component: "exception06", exception: true });
    },
    moveTab(boardId, moveType, key) {
      const name = this.projectId ? `${moveType}|tab` : `root|${moveType}|tab`;
      if (moveType === 'excel-upload' || moveType === 'page') return this.$router.push({ name, params: { boardId } });

      if (boardId) {
        if (this.projectId) {
          this.$router.push({ name: "list|tab", params: { boardId } });
        } else {
          this.$router.push({ name: "root|list|tab", params: { boardId } });
        }
      }
      if (key) {
        if (key === "아차사고D/B") {
          const breadcrumb = [{ title: "아차사고" }, { title: "아차사고관리" }, { title: "아차사고 D/B" }];
          if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
          this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
        } else if (key === "현장대리인_안전보건_경영방침") {
          this.$router.push({ name: "list|tab", params: { boardId: "현장대리인_안전보건_경영방침" } });
        } else if (key === "checkCerebrovascular") {
          this.$router.push({ name: "list|tab", params: { boardId: "checkCerebrovascular" } });
        }
      }
    },

    // ===== API =====
    async loadBoardPost() {
      const boardId = this.boardId;
      const postId = this.$route.params.postId;
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.docProjectId = post.project_id;
      if (post.post_content) {
        this.form = JSON.parse(post.post_content);
        if (!this.form.body["fileList"]) {
          this.form.body.fileList = [];
        }
        if (!this.form.body["formList"]) {
          this.form.body.formList = [];
        }
      }
    },
    async saveBoardPost(type) {
      let normalDocument = this.$refs["normalDocument"];
      // 만약 normalDocument 값이 배열일 경우, 배열의 첫번째 값을 가져온다
      if (Array.isArray(normalDocument)) {
        normalDocument = normalDocument[0];
      }

      // 만약 normalDocument.validate 메서드가 존재하면 호출한다
      if (normalDocument.validate) {
        const validated = normalDocument.validate();
        // 검증 실패했으면 빠져나간다
        if (!validated) {
          return;
        }
      }

      const form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form.enc = this.form.body.enc;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    loadApprovalPostContent(form) {
      const body = form.body;
      if (this.boardId === 117) {
        const targetKeys = [
          "inputC_1",
          "inputC_2",
          "inputC_4",
          "inputC_5",
          "inputC_7",
          "inputC_8",
          "inputC_9",
          "inputC_10",
          "inputC_11",
          "inputC_12",
          "inputC_13",
          "inputC_14",
          "inputC_15",
          "inputC_16",
          "inputC_17",
          "inputC_18",
          "inputC_19",
          "inputC_20",
          "inputD_1",
          "inputD_2",
          "inputD_3",
          "inputD_4",
          "inputD_5",
          "inputD_6",
          "inputD_7",
          "inputE_1",
          "inputE_2",
          "inputE_3",
          "inputE_4",
        ];
        for (const key of targetKeys) {
          if (typeof form.enc !== "undefined" && typeof form.enc[key] !== "undefined") {
            body[key] = form.enc[key];
          }
        }
      } else if (this.boardId === 126) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 136) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 138) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 141) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }
      }
      return form;
    },
    async loadApprovalPost() {
      const boardSlug = this.boardSlug;
      const postId = this.$route.params.postId;
      let post = {};
      await this.$store.dispatch("approval/LOAD_POST", { boardSlug, postId }).then((value) => {
        post = value.post;
        this.docProjectId = post.id;
        return value;
      });

      if (!this.$store.state.approval.postInfo) {
        alert("열람 권한이 없습니다.");
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onMoveNormalPage("list");
        return;
      }
      // 내용
      if (post.post_content) {
        let form = JSON.parse(post.post_content);

        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }

        // enc 내용을 본문에 추가하기
        form = this.loadApprovalPostContent(form);
        this.form = form;
      }

      // TODO : 결재프로세스
      const doc = this.$store.state.approval.document;
      this.docInfo = doc;
      this.docInfo.slug = this.boardSlug;
    },
    async saveApprovalPost(type, approvalLine) {
      const approvalDocument = this.$refs["approvalDocument"];
      if (approvalDocument.validate) {
        if (!approvalDocument.validate()) {
          return;
        }
      }

      let form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form = this.saveApprovalPostContent(form);

      const projectId = this.projectId;
      const boardSlug = this.boardSlug;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "n",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "create_upload") {
        await this.$store.dispatch("approval/CREATE_POST", {
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      } else if (type === "upload") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "y",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    saveApprovalPostContent(form) {
      const body = form.body;

      // 86
      if (this.boardId === 86) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 106
      else if (this.boardId === 106) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      } else if (this.boardId === 117) {
        form = this.saveApprovalPostContent117(form);
      }

      // 126
      else if (this.boardId === 126) {
        form = this.saveApprovalPostContent126(form);
      }

      // 136
      else if (this.boardId === 136) {
        form = this.saveApprovalPostContent136(form);
      }

      // 138
      else if (this.boardId === 138) {
        form = this.saveApprovalPostContent138(form);
      }

      // 141
      else if (this.boardId === 141) {
        form = this.saveApprovalPostContent141(form);
      }

      // 154
      else if (this.boardId === 154) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 155
      else if (this.boardId === 155) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      // 250
      else if (this.boardId === 250) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.removeComma(data.value1);
            data.value2 = this.removeComma(data.value2);
            data.value3 = this.removeComma(data.value3);
          }
        }
      }

      return form;
    },

    saveApprovalPostContent117(form) {
      const body = form.body;
      const targetKeys = [
        "inputC_1",
        "inputC_2",
        "inputC_4",
        "inputC_5",
        "inputC_7",
        "inputC_8",
        "inputC_9",
        "inputC_10",
        "inputC_11",
        "inputC_12",
        "inputC_13",
        "inputC_14",
        "inputC_15",
        "inputC_16",
        "inputC_17",
        "inputC_18",
        "inputC_19",
        "inputC_20",
        "inputD_1",
        "inputD_2",
        "inputD_3",
        "inputD_4",
        "inputD_5",
        "inputD_6",
        "inputD_7",
        "inputE_1",
        "inputE_2",
        "inputE_3",
        "inputE_4",
      ];

      const maskedName = this.maskName(body.inputC_1);

      // 암호화
      form.enc = {};
      for (const key of targetKeys) {
        form.enc[key] = body[key];
        body[key] = "";
      }
      body.inputC_1 = maskedName;

      form.body = body;
      return form;
    },

    saveApprovalPostContent126(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent136(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent138(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    saveApprovalPostContent141(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(",", "");
        return `${Number(noneComma)}`;
      }
      return "0";
    },

    onClickApprovalClose() {
      // 닫기
      this.onMoveNormalPage("list");
    },

    //
    // ===== Approval Doc Method =====
    //
    onClickApprovalSave(approvalLine) {
      if (this.postId) {
        this.saveApprovalPost("update", approvalLine);
      } else {
        this.saveApprovalPost("create", approvalLine);
      }
    },
    onClickApprovalUpload(approvalLine) {
      // 상신
      if (this.postId) {
        this.saveApprovalPost("upload", approvalLine);
      } else {
        this.saveApprovalPost("create_upload", approvalLine);
      }
    },
    onClickApprovalRecall(approvalLine) {
      // 결재문서 회수
      if (confirm("회수 후 임시저장 상태로 변경하시겠습니까?")) {
        this.saveApprovalPost("update", approvalLine);
      }
    },
    async onClickApprovalDelete() {
      // 삭제
      if (confirm("삭제하시겠습니까?")) {
        const boardSlug = this.boardSlug;
        const postId = this.$route.params.postId;
        await this.$store.dispatch("approval/DELETE_POST", {
          boardSlug,
          postId,
        });
        this.oldForm = JSON.parse(JSON.stringify(this.form));
        this.onClickApprovalClose();
      }
    },
    async onClickApprovalOk() {
      // 승인
      const postId = this.$route.params.postId;
      await this.$store.dispatch("approval/APPROVE_OK", { postId });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onClickApprovalClose();
    },
    async onClickApprovalNo(text) {
      // 반려
      const postId = parseInt(this.$route.params.postId);
      const comment = text;
      await this.$store.dispatch("approval/APPROVE_NO", { postId, comment });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onClickApprovalClose();
    },
    async onClickReTempsave(approvalLine) {
      if (confirm("재상신을 할 경우,\n기존 문서는 유지 되고, 내용이 복사되어 임시저장됩니다.\n재상신 하시겠습니까?")) {
        this.saveApprovalPost("create", approvalLine);
      }
    },
    onClickPrevPost() {
      this.showLoadPrevBoardPopup = true;
    },
    updatePrevForm(data) {
      if (this.boardId === 261) {
        delete data.headerDate;
        delete data.stdInfo;
        delete data.fieldInfo;

        delete data.hideBudgetDay1;
        delete data.hideBudgetDay2;
        delete data.budgetDay1Total;
        delete data.budgetDay2Total;

        const budgetDay1 = data.budgetDay1.map((_day) => {
          return { ..._day, readonly: false, yesterday: 0, total: 0 };
        });
        const budgetDay2 = data.budgetDay2.map((_day) => {
          return { ..._day, readonly: false, yesterday: 0, total: 0 };
        });

        this.form.body = { ...this.form.body, ...data, budgetDay1, budgetDay2 };

        const setBudgetDayOldData = new CustomEvent("setBudgetDayOldData");
        window.dispatchEvent(setBudgetDayOldData);
      } else {
        this.form.body = data;
      }
    },

    //
    // ===== Normal Doc Method =====
    //
    onClickNormalSave() {
      if (this.postId) {
        this.saveBoardPost("update");
      } else {
        this.saveBoardPost("create");
      }
    },
    async onClickNormalRemove() {
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      const boardId = this.boardId;
      const postId = this.postId;
      await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.onMoveNormalPage("list");
    },
    onMoveNormalPage(type) {
      const proj_id = `${this.projectId}`;
      const boardId = `${this.boardId}`;
      const query = this.$route.query;
      if (type === "list") {
        this.$router.push({ name: "list|tab", params: { proj_id, boardId }, query });
      }
    },
    saveButtonContorl(value) {
      this.$refs.refNormalDocument[0].saveButtonContorl(value);
    },
    handleEnableSave(enableSave) {
      this.enableSave = enableSave;
    },
    maskName(name) {
      name = `${name}`.trim();
      // 이름이 2개 이상의 단어로 이루어져 있는 경우
      if (name.includes(" ")) {
        // 이름을 공백으로 분리
        const names = name.split(" ");
        // 성은 맨 뒤 단어로 판단
        const lastName = names[names.length - 1];
        // 나머지 이름에 대해 마스킹 처리
        const otherNames = names.slice(0, -1).map((n) => n.substring(0, Math.ceil(n.length / 2)) + "*".repeat(Math.floor(n.length / 2)));
        return [...otherNames, lastName].join(" ");
      }

      // 이름이 1개의 단어로 이루어져 있는 경우
      const length = name.length;
      if (length === 1) {
        return "*";
      } else if (length === 2) {
        return `${name[0]}*`;
      } else {
        return name[0] + "*".repeat(length - 2) + name[length - 1];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#print-label {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
